// Sample quiz data for testing
import { collection, addDoc, doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export const sampleQuizzes = [
  {
    id: "quiz-math-101",
    title: "Mathematics Quiz - Algebra Basics",
    description: "Test your knowledge of basic algebra concepts including equations and inequalities.",
    duration: 30,
    questionCount: 10,
    dueDate: "2024-12-31",
    createdBy: "teacher-123",
    assignedTo: [], // Will be filled with actual student UIDs
    isActive: true,
    createdAt: new Date().toISOString(),
    questions: [
      {
        id: "q1",
        type: "multiple-choice",
        question: "What is the value of x in the equation: 2x + 5 = 15?",
        options: ["x = 3", "x = 5", "x = 7", "x = 10"],
        correctAnswer: "x = 5",
        points: 1
      },
      {
        id: "q2", 
        type: "multiple-choice",
        question: "Solve for y: 3y - 7 = 14",
        options: ["y = 5", "y = 7", "y = 9", "y = 11"],
        correctAnswer: "y = 7",
        points: 1
      },
      {
        id: "q3",
        type: "multiple-choice", 
        question: "What is the slope of the line y = 2x + 3?",
        options: ["2", "3", "2x", "5"],
        correctAnswer: "2",
        points: 1
      },
      {
        id: "q4",
        type: "true-false",
        question: "The equation x² = 16 has only one solution.",
        options: ["True", "False"],
        correctAnswer: "False",
        points: 1
      },
      {
        id: "q5",
        type: "multiple-choice",
        question: "Simplify: (x + 3)(x - 2)",
        options: ["x² + x - 6", "x² - x + 6", "x² + 5x - 6", "x² - 5x + 6"],
        correctAnswer: "x² + x - 6",
        points: 2
      }
    ]
  },
  {
    id: "quiz-science-101",
    title: "Science Quiz - Basic Chemistry",
    description: "Fundamental chemistry concepts including periodic table and chemical reactions.",
    duration: 45,
    questionCount: 12,
    dueDate: "2024-12-25",
    createdBy: "teacher-456",
    assignedTo: [],
    isActive: true,
    createdAt: new Date().toISOString(),
    questions: [
      {
        id: "q1",
        type: "multiple-choice",
        question: "What is the chemical symbol for Gold?",
        options: ["Go", "Gd", "Au", "Ag"],
        correctAnswer: "Au",
        points: 1
      },
      {
        id: "q2",
        type: "multiple-choice", 
        question: "How many protons does a Carbon atom have?",
        options: ["4", "6", "8", "12"],
        correctAnswer: "6",
        points: 1
      },
      {
        id: "q3",
        type: "true-false",
        question: "Water has the chemical formula H2O.",
        options: ["True", "False"],
        correctAnswer: "True",
        points: 1
      },
      {
        id: "q4",
        type: "multiple-choice",
        question: "What type of bond is formed between sodium and chlorine in salt?",
        options: ["Covalent", "Ionic", "Metallic", "Hydrogen"],
        correctAnswer: "Ionic",
        points: 2
      }
    ]
  },
  {
    id: "quiz-history-101",
    title: "History Quiz - World War II",
    description: "Test your knowledge of major events and figures from World War II.",
    duration: 25,
    questionCount: 8,
    dueDate: "2024-12-20",
    createdBy: "teacher-789",
    assignedTo: [],
    isActive: true,
    createdAt: new Date().toISOString(),
    questions: [
      {
        id: "q1",
        type: "multiple-choice",
        question: "In which year did World War II begin?",
        options: ["1938", "1939", "1940", "1941"],
        correctAnswer: "1939",
        points: 1
      },
      {
        id: "q2",
        type: "multiple-choice",
        question: "Which event brought the United States into World War II?",
        options: ["D-Day", "Battle of Britain", "Pearl Harbor", "Battle of Stalingrad"],
        correctAnswer: "Pearl Harbor",
        points: 1
      },
      {
        id: "q3",
        type: "true-false",
        question: "The D-Day invasion took place on June 6, 1944.",
        options: ["True", "False"],
        correctAnswer: "True",
        points: 1
      },
      {
        id: "q4",
        type: "multiple-choice",
        question: "Who was the British Prime Minister during most of World War II?",
        options: ["Neville Chamberlain", "Winston Churchill", "Clement Attlee", "Anthony Eden"],
        correctAnswer: "Winston Churchill",
        points: 2
      }
    ]
  }
];

// Function to add sample quizzes to Firestore
export async function addSampleQuizzes() {
  try {
    console.log("Adding sample quizzes to Firestore...");
    
    for (const quiz of sampleQuizzes) {
      // Use setDoc with custom ID instead of addDoc for predictable IDs
      await setDoc(doc(db, "quizzes", quiz.id), quiz);
      console.log(`Added quiz: ${quiz.title}`);
    }
    
    console.log("✅ Sample quizzes added successfully!");
    return true;
  } catch (error) {
    console.error("Error adding sample quizzes:", error);
    return false;
  }
}

// Function to assign quizzes to a specific student
export async function assignQuizzesToStudent(studentUID) {
  try {
    console.log(`Assigning quizzes to student: ${studentUID}`);
    
    for (const quiz of sampleQuizzes) {
      const quizRef = doc(db, "quizzes", quiz.id);
      // Update the assignedTo array to include the student UID
      const updatedQuiz = {
        ...quiz,
        assignedTo: [studentUID]
      };
      await setDoc(quizRef, updatedQuiz);
    }
    
    console.log("✅ Quizzes assigned to student!");
    return true;
  } catch (error) {
    console.error("Error assigning quizzes:", error);
    return false;
  }
}